<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
<template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

    <qr-edit-gateway
      v-model="showGatewayPopup"
      :sections="specialInfoSingle"
      :form-data="data"
      @edit-all="handleEditAll"
      @save="qrUpdate(true)"
      @cancel="onCancel"
    >
    <template v-slot:preview style="position: relative; min-height: 100%;">
      <div class="sticky-preview">
        <component
          :is="theme"
          v-model="data"
          :data="data"
          :orders.sync="orders"
          :key="previewKey+'-'+currentEditingLang + '-' + theme"
          :qr-svg-data-url="qrSvgDataUrl"
        />
        </div>
    </template>
    </qr-edit-gateway>

      <v-row class="mx-auto pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col class="pa-2" cols="12">
          <v-progress-linear v-show="loading" height="5" indeterminate />
        </v-col>

        <v-col class="pa-2" cols="12" md="4" style="position: relative; min-height: 100%;">
          <div class="sticky-preview">

          <component
            :is="theme"
            v-model="data"
            :data="data"
            :orders.sync="orders"
            class="sticky-md"
            style="top: 110px"
            :key="currentEditingLang + '-' + theme"
            :qr-svg-data-url="qrSvgDataUrl"
          />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>

              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row">
                  <div class="col-md-12">
                    <p>{{ $t("enter_visit_card_info") }}</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        :error-messages="errors['title']"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        :label="$t('visit_card_name')"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-Qr-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('visit_card_name_label')"
                      />
                    </div>
                  </div>

                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        v-model="res.identifier"
                        :domain-id="res?.domain_id"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        outlined
                        persistent-hint
                        readonly
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"

                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-Qr-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('qr_address')"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <v-btn 
                      class="btn-edit rounded-lg ma-2" 
                      depressed 
                      @click="showAiDialog = true"
                    >
                      <v-icon left>mdi-magic-staff</v-icon>
                      دستیار هوش مصنوعی
                    </v-btn>
                  <AiCardGeneratorDialog
                    v-model="showAiDialog"
                    :card-data="data"
                    :orders="orders"
                    @apply="onAiCardApplied"
                    :theme="theme"
                  />
                  <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>


                <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                  :data="data"
                  @save-required="AutoSave && qrUpdate(false)"
                >
                  <template v-slot:content>
                    <theme-selector v-model="theme" :components="customTheme" />
                  </template>
                </list-expansion>
                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  @save-required="AutoSave && qrUpdate(false)"

                />
                <qr-generator v-model="data" @save-required="AutoSave && qrUpdate(false)"/>

                <div class="col-md-12">
                  <next-btn :loading="loading" @click="qrUpdate(true)" />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: $t('download') }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('download')"
            />
          </template>
          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${res?.domain?.name||'qrland.in/'}${res.identifier}`"
              :qr_id="res.qrId"
              :visit-name="res.title"
              link
              @close="showDialog = false"
            />
          </v-card>
        </custom-popup>
        <translate-language-loader-v-2 :color="'#D4AF37' || '#ff1d5e'" />
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import {AtomSpinner} from 'epic-spinners'
import { Bus, debounce } from "@/main";
import MobileViwer from "./components/mobileViwer";
import QrGenerator from "./components/qrGenerator";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "./components/qrManage/qrManagement";
import TextCards from "@/view/pages/qrland/components/textCards";
import QrAddressField from "../../content/fragments/qrAddressField";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import ThemeSelector from "./components/themes/themeSelector";
import VisitThemeTwo from "./components/themes/visitThemeTwo";
import VisitThemeFlipped from "./components/themes/visitThemeFlipped";
import { mapActions, mapGetters } from "vuex";
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import TranslateLanguageLoaderV2 from "../otherQrTypes/luckWheel/TranslateLanguageLoaderV2.vue";
import { setDragging } from "@/utilities/DraggingKeysOrder";
import AiCardGeneratorDialog from "./AiCardGeneratorDialog.vue";
import transitions from "vuetify/lib/components/transitions";
import DownloadFileWithApi from "./downloadFileWithApi.vue";
import QrEditGateway from "./components/QrEditGateway.vue";

export default {
  name: "editVisit",

  components: {
    ThemeSelector,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
    DownloadFileWithApi,
    TextCards,
    QrManagement,
    QrCustomize,
    QrGenerator,
    MobileViwer,
    VisitThemeTwo,
    VisitThemeFlipped,
    TranslateLanguageLoaderV2,
    QrEditGateway,
    AiCardGeneratorDialog,
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      AutoSave:false,
      isAutoSaving: false, 
      previewKey: 0, 
      showAiDialog:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      currentEditingLang: "fa",
      serviceName: "Qrland",
      componentName: "editVisit",
      helpData: [],
      showDialog: false,
      data: {},
      errors: {},
      finish: false,
      loading: false,
      e6: 1,
      qrLink: "",
      security: {},
      dtUrl: null,
      theme: "",
      orders: [],
      customTheme: [
        { name: "MobileViwer", value: "" },
        { name: "VisitThemeTwo", value: "" },
        { name: "VisitThemeFlipped", value: "" },
      ],
      res: {},
    };
  },

  watch: {
    data: {
      deep: true,
      handler(newVal) {
        debounce(() => {
          this.setKeys(newVal);
          //  this.syncToMobileViewer();
        }, 250);
      },
    },

        currentEditingLang() {
      this.syncToMobileViewer();
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    // theme(newTheme) {
    //   this.$root.$emit("visit-data-updated", {
    //     data: this.data,
    //     orders: this.orders,
    //     theme: newTheme,
    //     lang: this.currentLang,
    //   });
    // },
  },

  mounted() {
    this.$root.$on("mobile-viewer-updated", (payload) => {
      if (payload.lang === this.currentEditingLang) return;

      if (payload?.orders) {
        this.orders = [...payload?.orders];
      }
      if (payload?.data) {
        this.data = { ...payload?.data };
      }
      if (payload?.theme) {
        this.theme = payload?.theme;
      }
    });
    this.$root.$on("language-changed", ({ lang }) => {
      if (this.currentEditingLang === lang) return;
      this.currentEditingLang = lang;
    });
    Bus.$on("colorPalette", (value) => {
      this.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });

    // Bus.$on("uploader", (value) => {
    //   this.data.photo = value;
    // });

    Bus.$on("gradientType", (value) => {
      this.data.isGradient = value;
    });

    Bus.$on("audioType", (value) => {});

    this.$root.$on("qrUpdate", (payload) => {
      this.qrUpdate(false);
      //this.saveToLangFtp(this.currentEditingLang, false, payload);
    });
    this.fetchData();
    this.$nextTick(() => {
      this.setKeys(this.data);
      //  this.syncToMobileViewer();
    });
  },
  destroyed() {
    this.$root.$off("language-changed");
  },
  computed: {
    ...mapGetters("localstorage", [
      "createQrID",
      "alllangs",
      "defaultLang",
      "mainDatalang",
    ]),
    specialInfo() {
      return [
        {
          name: "managmentLanguage",
          value: "",
          title: this.$t("language.management_langs"),
          subtitle: "",
          icon: "translate",
          model: "langs",
          mainData: this.data,
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "customerClubSettings",
          title: this.$t("sms_membership_message"),
          icon: "cellphone-message",
          model: "customerClub",
        },
        {
          name: "advanceSettings",
          title: this.$t("smart_settings"),
          icon: "star-settings-outline",
          model: "advanceSettings",
        },
        {
          name: "voiceGallery",
          title: this.$t("add_audio_file"),
          icon: "microphone",
          model: "audiosGallery",
        },
      ];
    },
      specialInfoSingle() {
        return [
          {
            name: "textCards",
            value: "",
            title: this.$t("user_info"),
            subtitle: "",
            icon: "account-outline",
            description: this.$t(
              "editvisit.special_info_single.text_cards_description"
            ),
          },
          {
            name: "customerClubSettings",
            title: this.$t("sms_membership_message"),
            icon: "cellphone-message",
            model: "customerClub",
            description: this.$t(
              "editvisit.special_info_single.customer_club_settings_description"
            ),
          },
          {
            name: "advanceSettings",
            title: this.$t("smart_settings"),
            icon: "star-settings-outline",
            model: "advanceSettings",
            description: this.$t(
              "editvisit.special_info_single.advance_settings_description"
            ),
          },
          {
            name: "voiceGallery",
            title: this.$t("add_audio_file"),
            icon: "microphone",
            model: "audiosGallery",
            description: this.$t(
              "editvisit.special_info_single.voice_gallery_description"
            ),
          },
          {
            name: "VideoGallery",
            value: "",
            title: this.$t("add_video"),
            subtitle: "",
            icon: "video-image",
            description: this.$t(
              "editvisit.special_info_single.video_gallery_description"
            ),
            // model: "video_single",
          },
          {
            name: "imageUploader",
            value: "",
            title: this.$t("add_image"),
            subtitle: "",
            icon: "cloud-upload-outline",
            model: "photo",
            description: this.$t(
              "editvisit.special_info_single.image_uploader_description"
            ),
          },
          {
            name: "colorPallete",
            value: "",
            title: this.$t("select_color"),
            subtitle: "",
            icon: "format-color-fill",
            model: "pallete",
            description: this.$t(
              "editvisit.special_info_single.color_palette_description"
            ),
          },
          {
            name: "socialMediaIcons",
            value: "",
            title: this.$t("add_social_networks"),
            subtitle: "",
            icon: "instagram",
            model: "socialMedia",
            description: this.$t(
              "editvisit.special_info_single.social_media_icons_description"
            ),
          },
        ];
      },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },
  created() {
    this.$root.$on("editvisit-lang-change", (lang) => {
      this.currentEditingLang = lang;
    });

        this.$root.$on("lang-data-loaded", ({ lang, data }) => {
      this.currentEditingLang = lang;
      
      let target = data;

      while (
        target && 
        target.data && 
        target.theme === undefined && 
        target.orders === undefined
      ) {
        target = target.data;
      }

      if (target && target.data && typeof target.data === 'object') {
        this.data = target.data;
      } else {
        this.data = target || {};
      }
      this.orders = target?.orders || [];
      this.theme = target?.theme || 'MobileViwer';

      this.$root.$emit("visit-data-updated", {
        data: {
          data: this.data, 
          orders: this.orders,
          theme: this.theme,
          lang: this.currentEditingLang, 
        },
      });
      
      this.$forceUpdate();
    });

    this.$root.$on("lang-maindata-updated", (data) => {
      this.data = { ...data };
    });
    this.currentEditingLang = this.defaultLang;
  },
  beforeDestroy(){
    // this.resetToDefaultLanguage();
  },
  methods: {
    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setLangList",
      "setDefaultLang",
      "setMainData",
      "setCurrentLanguage"
    ]),
    onAiCardApplied({ data, saveFinal }) {
  console.log(data,"data",saveFinal,"savefinal")
  
  // ۱. آپدیت تم کارت در پنل اصلی
  if (data.theme) {
    this.theme = data.theme;
  }

  // ۲. آپدیت ساختار عمیق data
  this.data = {
    ...this.data,
    ...data.cardTexts,
  };

  // ۳. آپدیت orderها در صورت نیاز
  if (data.orders) {
    this.orders = [...data.orders];
  }

  Bus.$emit("colorPalette", this.data.pallete);
  Bus.$emit("socialMedias", this.data.socialMedia);
  Bus.$emit("uploader", this.data.photo);

  this.previewKey++; 

  this.$toast.success("طرح با موفقیت بر روی کارت اعمال شد");

  if (saveFinal) {
    this.$nextTick(() => this.qrUpdate(true));
  }
},
    resetToDefaultLanguage() {
          const baseLang = this.defaultLang || 'fa';
          this.setCurrentLanguage(baseLang);          
          if (this.currentEditingLang) {
            this.currentEditingLang = baseLang;
          }
        },
    onCancel() {
      this.resetToDefaultLanguage();
      this.goto('qr/list');
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },
    setKeys(val = this.cardTexts) {
      let keys = setDragging(val, this.orders);
      if (
        val.audiosGallery &&
        val.audiosGallery.audios &&
        val.audiosGallery.audios.length > 0
      ) {
        const audioKeys = val.audiosGallery.audios.map((_, index) => ({
          name: `audio_${index}`,
        }));
        keys = [
          ...keys.filter((key) => !key.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      keys = keys.filter((item) => item.name !== "audiosGallery");

      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language",
      );

      this.orders = keys;
      this.$forceUpdate();
    },

    syncToMobileViewer() {
      this.$root.$emit("visit-data-updated", {
        data: {
          data: JSON.parse(JSON.stringify(this.data)),
          orders: [...this.orders],
          theme: this.theme,
          lang: this.currentEditingLang,
        },
      });
    },
    // loadLangData(lang) {
    //   this.$api.get(`/langData?id=${this.qrId}&lang=${lang}`).then((res) => {
    //     const newData = res?.[0] || {};
    //     this.$root.$emit("visit-data-updated", {
    //       data: newData.data,
    //       orders: newData.orders || [],
    //       theme: newData.theme || "MobileViwer",
    //       lang: lang,
    //     });
    //   });
    // },
    fetchData() {
  this.loading = true;

  this.$api
    .get(
      `/v1/testQr/find/${this.domainName}${
        !!this.qrId ? "/" + this.qrId : ""
      }`
    )
    .then(({ data }) => {
      this.setCreatedQrID(data?.data?.id);
      this.qrSvgDataUrl= data?.data?.img_url||''; 
      this.setLangList(
        data?.data?.lang
          ?.split(",")
          ?.filter((l) => l !== data?.data?.default) || []
      );
      this.setDefaultLang(data?.data?.default || "fa");
      
      let info = data.data.data;
      
      if (!!data.data?.data?.orders) {
        this.orders = data?.data?.data?.orders;
      } else {
        this.orders = [
          { name: "userName" }, { name: "workField" }, { name: "aboutUs" },
          { name: "video_gallery" }, { name: "photo" }, { name: "extraFields" },
          { name: "phoneNumber" }, { name: "fax" }, { name: "location" },
          { name: "codePostal" }, { name: "email" }, { name: "website" }
        ];
      }

      try {
        if (info.data?.coordinates) {
          info.data.coordinates.sort((a, b) => b - a);
          info.data.center?.sort((a, b) => b - a);
        }
      } catch (e) {}

      if (!!info?.data?.photo) {
        info.data.photo = { ...info.data.photo, hasGame: false, hasGif: false };
      } else {
        info.data.photo = {};
      }
       const defaultPicSelector = {
        slider: true,
        grid: false,
        orientation: 'horizontal'
      };

      if (info?.data?.photo?.PicSelector) {
        info.data.photo.PicSelector = {
          ...defaultPicSelector,
          ...info.data?.PicSelector,
          ...info.data?.photo?.PicSelector

        };
      } else {
        info.data.photo.PicSelector = { ...defaultPicSelector };
      }
      if (!info.data.video_gallery) {
        info.data.video_gallery = [{ name: "", images: [] }];
      }

      if (!info.data?.audiosGallery) {
        info.data.audiosGallery = { audios: [], audioType: "newPlayer" };
      } else if (Array.isArray(info?.data?.audiosGallery)) {
        let audios = info?.data?.audiosGallery?.length > 0 ? info?.data?.audiosGallery : [];
        audios = audios.map(audio => ({ ...audio, autoPlay: audio.autoPlay || false }));
        info.data.audiosGallery = { audios: audios, audioType: "newPlayer" };
      } else if (info.data?.audiosGallery?.audios) {
        info.data.audiosGallery.audios = info.data.audiosGallery.audios.map(audio => ({
          ...audio, autoPlay: audio.autoPlay || false
        }));
      }

      // تنظیمات زبان
      info.data.language = this.defaultLang || getLanguageCookie() || info.data.language || "fa";
      
      if (!info.data.langs) info.data.langs = {};
      info.data.langs = {
        source_lang: this.defaultLang || info.data.langs.source_lang || "fa",
        other_langs: this.alllangs?.map((x) => ({ lang: x, status: "edited" })) || [],
      };

      // ۲. حالا فقط یک‌بار fixVideoGallery را صدا می‌زنیم و this.data را مقداردهی نهایی می‌کنیم
      let finalNormalizedData = this.fixVideoGallery(info.data);
      this.data = {
        ...finalNormalizedData,
        langs: info.data.langs,
      };

      if (info?.data?.theme && info?.data?.theme.length > 0) {
        this.theme = info?.data?.theme;
      } else if (info?.theme && info?.theme.length > 0) {
        this.theme = info?.theme;
      } else {
        this.theme = "MobileViwer";
      }

      this.res = data.data;
      this.qrLink = data.data.link;
      this.res.language = this.defaultLang || getLanguageCookie() || "fa";
      
      let emitData = {
        data: this.data,
        orders: this.orders,
        theme: this.theme,
        lang: this.data.language,
      };

      this.$root.$emit("visit-data-updated", { data: emitData });
      this.setMainData({ data: emitData });
    })
    .finally(() => {
      this.loading = false;
      this.$root.$emit("visit-data-updated", {
        data: {
          data: this.data || {},
          orders: this.orders,
          theme: this.theme,
          lang: this.currentEditingLang,
        },
      });
    });
},

    fixVideoGallery(data) {
      let d = { ...data };

      if (!!d.video_single?.videos?.length) {
        if (!d.hasOwnProperty("video_gallery"))
          d.video_gallery = [
            {
              name: d.video_single.name || this.$t("video_gallery"),
              images: d.video_single.videos,
            },
          ];
        else
          d.video_gallery.push({
            name: d.video_single.name || this.$t("video_gallery"),
            images: d.video_single.videos,
          });
      } else if (!d.hasOwnProperty("video_gallery"))
        d.video_gallery = [
          {
            name: this.$t("video_gallery"),
            images: [],
          },
        ];
      if (!!d.video_single) delete d.video_single;
      return d;
    },
    qrUpdate(final = false) {
       if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      // this.loading = true;
      this.errors = {};

      const currentLang = this.currentEditingLang; // || this.data.langs?.source_lang || "fa";
      const sourceLang = this.data.langs?.source_lang || "fa";
      const data = new URLSearchParams();
      data.append("type", "VisitCard");
      data.append("qrType", "dynamic");
      data.append("title", this.res.title);
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      this.data.language = this.defaultLang || getLanguageCookie() || "fa";
      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.data,
          orders: this.orders,
        }),
      );

      if (currentLang === sourceLang) {
        return this.saveToMainQr(data, final);
      } else {
        let content = {
          data: {
            data: this.data,
            theme: this.theme,
            orders: this.orders,
          },
        };
        return this.saveToLangFtp(currentLang, final, content);
      }
    },
    saveToMainQr(data, final) {
      return this.$api
        .put("/v1/testQr/update", data, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then(() => {
          if(final || !this.isAutoSaving)
          this.$toast.success(this.$t("visit_card_edited_successfully"));
        })
        .catch((err) => this.handleError(err))
        .finally(() => {
          this.isAutoSaving =false;
          
          this.loading = false;
          if(final)
          {

            this.resetToDefaultLanguage();
            this.goto("qr/list");
          }
        });
    },
    saveToLangFtp(lang, final, content) {
      const allLangs_1 = [this.defaultLang || "fa", ...(this.alllangs || [])];

      return this.$api
        .post(`/v1/testQr/update-lang-data/${this.createQrID}`, {
          lang: lang,
          data: content,
          langs: allLangs_1,
        })
        .then(() => {
          if (final)
          this.$toast.success(this.$t("language.saved"));
          this.isAutoSaving =false;
          if (final) {
            this.resetToDefaultLanguage();
            this.goto("qr/list");}
        })
        .catch((err) => this.handleError(err))
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false; });
    },
  },
};
</script>
<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 4;
}
</style>